import React from "react";
import { PageShell } from "../components/Layout";
import SeoContent from "../components/SeoContent";
import { api } from "../services/api";
import { TrendingUp, RefreshCw } from "lucide-react";
import useSeo from "../hooks/useSeo";

export default function Analysis() {
  const [data, setData] = React.useState({ guti: [], date: "" });
  useSeo({
    title: "Sunday Ground Teer Analysis & Daily Guti | Teer Number Analysis",
    description:
      "Sunday Ground Teer Analysis with today's Daily Guti numbers, auto-updated from previous Shillong Teer results. Study patterns for better reference.",
  });

  React.useEffect(() => {
    api.analysis().then(setData).catch(() => {});
  }, []);

  return (
    <>
      <PageShell title="Analysis Teer" subtitle="Daily Guti — auto-updated from previous results">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-2 text-[#1aa79a] font-bold mb-1">
            <TrendingUp className="w-5 h-5" />
            <span>Today's Daily Guti</span>
          </div>
          <p className="text-center text-xs text-gray-400 mb-5 flex items-center justify-center gap-1">
            <RefreshCw className="w-3 h-3" /> Auto changes daily • {data.date}
          </p>
          <div className="grid grid-cols-4 gap-3">
            {data.guti.map((g, i) => (
              <div
                key={i}
                className="aspect-square rounded-xl bg-gradient-to-br from-[#1fb5a6] to-[#12897d] text-white flex items-center justify-center text-2xl font-black shadow"
              >
                {g}
              </div>
            ))}
          </div>
        </div>
        <p className="text-center text-xs text-gray-400 mt-4">
          * Analysis (Guti) numbers are calculated automatically every day. For reference only.
        </p>
      </PageShell>
      <SeoContent variant="home" />
    </>
  );
}
